import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

import Template from '../templates/template';

import BrandBlock from '../components/brand-block';

const Brands = inject("stores") (
    observer (
        class Brands extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;
                this.storeUi = this.props.stores.storeUi;

                this.state = {
                    brand: '',
                    slides : []
                }

                this.reactSwiper = [];              
            }

            componentDidMount = async() => {
                if (this.props.match.params.brand !== undefined) {
                    this.setState({
                        brand: this.props.match.params.brand
                    });
                }

                const slides_japantky = await this.storeUi.getDataCarousel('japantky');
                const slides_inti = await this.storeUi.getDataCarousel('inti');
                const slides_marivie = await this.storeUi.getDataCarousel('marivie');
                const slides_talkingwalls = await this.storeUi.getDataCarousel('talkingwalls');
                const slides_lasalle = await this.storeUi.getDataCarousel('lasalle');

                this.setState({
                    slides: {
                        japantky: slides_japantky,
                        inti: slides_inti,
                        marivie: slides_marivie,
                        talkingwalls: slides_talkingwalls,
                        lasalle: slides_lasalle
                    }
                })

                this.alternateSliders();
            }

            componentDidUpdate = (prevProps) => {
                if (prevProps.match.params.brand !== this.props.match.params.brand) {
                    if (this.props.match.params.brand !== undefined) {
                        this.setState({
                            brand: this.props.match.params.brand
                        });
                    } else {
                        this.setState({
                            brand: ''
                        });
                    }
                }
            }

            getRandomInt(max) {
                return Math.floor(Math.random() * max);
              }

            alternateSliders = () => {
                let rnd;

                const interval = setInterval(() => {
                    rnd = this.getRandomInt(4);
                    if (this.reactSwiper[rnd]) {
                        this.reactSwiper[rnd].swiper().slideNext();
                    }
                }, 3500);
            }

            handleBrand = (brand) => {
                this.setState({
                    brand: brand
                });
                const url = "/brands/" + brand;
                this.props.history.push(url);
            }

            handleBack = () => {
                this.setState({
                    brand: ''
                });
                const url = "/brands";
                this.props.history.push(url);
            }

            render() {
                return (
                    <Template>
                        <div class="container-content">
                            <div class="content-columns">
                                <div class="content-column">
                                    <h1>Brands</h1>
                                </div>
                            </div>
                            
                            {this.state.brand === '' &&
                                <div className="container--navigation">
                                    <div class="content-columns">
                                        <div class="content-column">
                                            <div className="block--brands">
                                                {this.storeUi.sub_nav[0].values.map((nav_item, idx) => (
                                                    parseInt(nav_item.active) === 1 &&
                                                        <div className="block--brand">
                                                            <div className="container--swiper">
                                                                <Swiper 
                                                                    ref={(c) => { this.reactSwiper[idx] = c }}
                                                                    swiperOptions={{
                                                                        slidesPerView: 1,
                                                                        autoplay: false,
                                                                        effect: 'fade',
                                                                        loop: false,
                                                                        speed: 2000
                                                                    }}
                                                                    {...this.state.options}
                                                                >
                                                                    {this.state.slides[nav_item.name] && this.state.slides[nav_item.name].map((img, i) => (
                                                                        <SwiperSlide key={i}>
                                                                            <span 
                                                                                className = "--link"
                                                                                onClick = {() => this.handleBrand(nav_item.name)}
                                                                                style={{ backgroundImage: `url(${this.urlAPI + "/adam/"+ img})` }}
                                                                            />
                                                                        </SwiperSlide>
                                                                    ))}
                                                                </Swiper> 
                                                            </div>
                                                            <div className="block--brand__logo --link" onClick={() => this.handleBrand(nav_item.name)}>
                                                                <img src={this.urlAPI + "/adam/public/images/brands/logo-" + nav_item.name + "-trans.png"} />
                                                            </div>
                                                        </div>
                                                ))}
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            }

                            {this.state.brand !== '' &&
                                this.storeUi.sub_nav[0].values.map((nav_item) => (
                                    (parseInt(nav_item.active) === 1 && nav_item.name === this.state.brand) && 
                                        <BrandBlock
                                            section = {"brands"}
                                            brand = {nav_item.name}
                                            item = {nav_item}
                                            handleBack = {this.handleBack}
                                        />
                                ))
                            }
                                  
                        </div>
                    </Template>
                );
            }
        }
    )
)

export default Brands;
